import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import NewMedicalNetwork from './NewMedicalNetwork';
import './styles.scss';

function FeatureToggleMedicalNetwork() {
  return <NewMedicalNetwork />;
}

const mapStateToProps = ({wizard}: any) => ({
  wizard: wizard.value,
});

export default compose(connect(mapStateToProps)(FeatureToggleMedicalNetwork));
